<div class="cb-columns">
    @for (col of columns(); track col.path.join('|'); let columnIndex = $index) {
        <div class="cb-column" [attr.data-path]="columnPath(col)">

            <!-- Column title — same shape for every column kind. Path
                 badge is the common identifier; array columns add a count
                 + Add button; every non-root column gets a delete in the
                 trailing right slot. -->
            <div class="cb-column-title">
                <code class="cb-path">{{ columnPath(col) }}</code>
                @if (col.kind === 'array') {
                    <span class="cb-array-count">
                        {{ col.value.length }} {{ col.value.length === 1 ? 'item' : 'items' }}
                    </span>
                }
                @if (col.schema?.readOnly === true) {
                    <mat-icon class="cb-readonly-icon"
                              matTooltip="Read-only — defined on the UserDataType">lock</mat-icon>
                }
                <span class="cb-flex-spacer"></span>
                @if (canAddToColumn(col)) {
                    <button type="button" mat-stroked-button class="cb-add-btn"
                            (click)="addArrayItem(columnIndex)">
                        <mat-icon>add</mat-icon> Add
                    </button>
                }
                @if (canDeleteColumn(col)) {
                    <button type="button" class="cb-column-delete"
                            [matTooltip]="deleteTooltip(col)"
                            [attr.aria-label]="deleteTooltip(col)"
                            (click)="deleteColumn(columnIndex, $event)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                }
            </div>

            <!-- Column body — depends on the column's kind. -->
            <div class="cb-column-body" [class.cb-column-body--leaf]="col.kind === 'leaf'">
                @if (col.kind === 'leaf') {
                    <app-schema-leaf-editor
                            [schema]="col.schema"
                            [value]="col.value"
                            [path]="columnPath(col)"
                            [disabled]="disabled"
                            (valueChange)="onLeafValueChange(columnIndex, $event)"
                            (pathCleared)="pathCleared.emit($event)" />
                } @else if (col.kind === 'object') {
                    <app-schema-form
                            [columnMode]="true"
                            [schema]="col.schema"
                            [value]="col.value"
                            [disabled]="disabled"
                            [pathPrefix]="col.path"
                            [selectedSegment]="selectedSegmentFor(columnIndex)"
                            (valueChange)="onColumnValueChange(columnIndex, $event)"
                            (openPath)="onOpenPath(columnIndex, $event)"
                            (pathCleared)="pathCleared.emit($event)"
                            (focusPath)="focusPath.emit($event)" />
                } @else if (col.kind === 'array') {
                    @for (item of col.value; track $index; let i = $index) {
                        <div class="cb-nav-row"
                             [class.cb-nav-selected]="selectedSegmentFor(columnIndex) === '[' + i + ']'"
                             [attr.data-path]="arrayItemPath(col, i)"
                             (click)="onOpenPath(columnIndex, '[' + i + ']')">
                            <mat-icon class="cb-nav-kind-icon">label_important</mat-icon>
                            <span class="cb-nav-name">[{{ i }}]</span>
                            <span class="cb-nav-preview">{{ summarizeItem(item) }}</span>
                            <mat-icon class="cb-nav-chevron">chevron_right</mat-icon>
                        </div>
                    }
                    @if (col.value.length === 0) {
                        <div class="cb-empty">No items. Click <em>Add</em> to create one.</div>
                    }
                }
            </div>
        </div>
    }
</div>
